import { render, staticRenderFns } from "./CustomerAnalyze.vue?vue&type=template&id=fbfaa69e&scoped=true"
import script from "./CustomerAnalyze.vue?vue&type=script&lang=js"
export * from "./CustomerAnalyze.vue?vue&type=script&lang=js"
import style0 from "./CustomerAnalyze.vue?vue&type=style&index=0&id=fbfaa69e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfaa69e",
  null
  
)

export default component.exports